import FunctionSerializer from './function-serializer';
import CriteriaSerializer from './criteria-serializer';
import EntitySerializer from './entity-serializer';
import EntityCollectionSerializer from './entity-collection-serializer';
import HandleErrorSerializer from './handle-error-serializer';
import cloneDeepWith from 'lodash/cloneDeepWith';
import MissingPrivilegesErrorSerializer from './missing-priviliges-error-serializer';
/**
 * Collect all single serializer/deserializer. The first matching result
 * will be used as the customizer in cloneDeepWith
 */
const serializerFactories = [
    CriteriaSerializer,
    EntityCollectionSerializer,
    EntitySerializer,
    FunctionSerializer,
    HandleErrorSerializer,
    MissingPrivilegesErrorSerializer,
];
/**
 * The main serializer factory. It returns a general serializer/deserializer which combines
 * all single serializer
 */
export default function mainSerializerFactory(dependencies) {
    const serializers = serializerFactories.map(serializerFactory => serializerFactory(dependencies));
    function getSerializers() {
        return serializers;
    }
    function getSerializerByName(name) {
        var _a;
        return (_a = serializers.find(serializer => serializer.name === name)) !== null && _a !== void 0 ? _a : null;
    }
    /* eslint-disable */
    function serialize(messageData) {
        return cloneDeepWith(messageData, (value, key, object, stack) => {
            // return first matching serializer result
            for (const serializer of serializers) {
                const result = serializer.serialize({
                    value,
                    key,
                    object,
                    stack,
                    customizerMethod: serialize,
                });
                if (result) {
                    return result;
                }
                ;
            }
        });
    }
    function deserialize(messageData, event) {
        return cloneDeepWith(messageData, (value, key, object, stack) => {
            // return first matching serializer result
            for (const serializer of serializers) {
                const result = serializer.deserialize({
                    value,
                    key,
                    object,
                    stack,
                    event,
                    customizerMethod: deserialize,
                });
                if (result) {
                    return result;
                }
                ;
            }
        });
    }
    /* eslint-enable */
    return {
        getSerializers,
        getSerializerByName,
        serialize,
        deserialize,
    };
}
//# sourceMappingURL=index.js.map